import { render, staticRenderFns } from "./FloatingPanelsStack.vue?vue&type=template&id=f0b07f32&scoped=true"
import script from "./FloatingPanelsStack.vue?vue&type=script&lang=js"
export * from "./FloatingPanelsStack.vue?vue&type=script&lang=js"
import style0 from "./FloatingPanelsStack.vue?vue&type=style&index=0&id=f0b07f32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b07f32",
  null
  
)

export default component.exports